<template>
  <div class="content">

    <loading v-if="!showLoading"></loading>

    <div v-if="showLoading">
      <div class="tc" v-if="isHave" style="position: absolute; width: 100%;height: 100vh;background: #FFF;">
        <img style="width: 8rem;margin-top: 3rem" src="@/images/quesheng-copy.png"/>
        <div class="zt14" style="color:#d4237a;width:20rem;margin: 2rem auto 0;text-align: center;">
          {{toastDesc}}
        </div>
      </div>
      <div class="kinter">

      <div v-if="!isHave" style="width:100%; backgroundImage:'url(' + backImgUrl +')';" id="back" class="gametun_bg" >
        <img class="full_w" :src="backImgUrl" style="">
<!--        <img class="full_w" :src="backImgUrl" v-if="backImgUrl!=''" style="">-->

        <div class="gamebanner_img">
          <van-swipe :autoplay="3000" :width="707" :height="140" indicator-color="#db4933">
            <van-swipe-item v-for="(image, index) in prize_adv" :key="index">
              <a :href="image.contentUrl">
              <img v-lazy="image.imageUrl" class="gamebanner_img_in" />
              </a>
            </van-swipe-item>
          </van-swipe>
          <div class="swiper_buttomIn"></div>
        </div>

        <div class="conts">
          <div class="conts_king">
            <div class="conts_king_in">
              <div class="conts_king_left"><span class="conts_inter">我的K币</span> <span class="pad_in">{{useDetail.pointAccountNum}}</span></div>
            </div>
            <div class="conts_king_in2">
              <div class="conts_king_right">{{score}}K币=抽奖一次</div>
              <div class="conts_king_bottom">免费抽奖次数<span class="pad_in2">{{useDetail.freeCount}}</span>次</div>
            </div>

          </div>
          <div style="height: 2.95rem; width: 100%; position: absolute; top: 9.5rem; z-index: 2">
            <div class="conts_lon">
              <img :src="prize_noimg" style="width: 4.4rem; height: 2.2rem; position: absolute">
              <button style="width:4.4rem;height: 2.2rem; opacity: 0;" id="rule" @click="showRuleView=true">活动规则</button>
            </div>
            <div class="conts_ron">
              <img :src="prize_moimg" style="width: 4.4rem; height: 2.2rem; position: absolute">
              <button style="width:4.4rem;height: 2.2rem; opacity: 0;" id="record" @click="prizeAction();showListView=true">抽奖记录</button>
            </div>
          </div>
          <div class="conts_music">
<!--            <img src="@/images/sy_guan.png" v-if="mus_pause" class="bt_yinyue2" @click="musicPause();">-->
<!--            <img src="@/images/sy_kai.png" v-if="mus_play" class="bt_yinyue1" @click="musicPlay();">-->
            <div @click="changeOn" :class="isOffClass"></div>
          </div>
          <div class="box" style="position: absolute;top: 11.2rem;margin: 0 auto">
            <!---->
            <!--<p class="black zt12 blod tc" style="padding: 0 2rem;height: 1.5rem;line-height: 1.5rem;margin-top: 0.6rem;margin-bottom: 0;" v-if="currentActionIndex!='无限'">今天还有{{currentActionIndex}}次抽奖机会</p>-->

            <!--抽奖按钮的背景图-->
            <div class="pointer" @click="setClickActionPromission()" v-if="pointerLinte">
              <img :src="buttonImgUrl" style="width:3.9375rem;" :style="{}">
              <!--<p class="zt18 blod white" style="position: relative;top: -4.4rem;color:white;font-size:1.125rem;font-weight: bold;">GO</p>-->
            </div>
            <!--抽奖按钮的背景图-->
            <div class="pointer" v-if="pointerHent">
              <img :src="buttonImgUrl" style="width:3.9375rem;" :style="{}">
              <!--<p class="zt18 blod white" style="position: relative;top: -4.4rem;color:white;font-size:1.125rem;font-weight: bold;">GO</p>-->
            </div>

            <div class="boxbg_ing">
              <div style="width:100%;height: 100%;" class="box_iner" >
                <img :src="turnImgUrl" style=" width: 100%; height: 100%" />
              </div>
              <div class="boxbg" style="transform: scale(1.28);">
                <!--<img src="@/images/boxCircle@3x.png" style="width:100%;height: 100%;">-->


                <div class="turn" style="width: 15rem; height: 15rem; position: absolute; top: 4.5rem; left: 4.2rem;" :style="{transform:rotate_angle,transition:rotate_transition}">
                  <div :class="{'wheel-bg6':true}">
                    <div class="prize-list">
                      <ul class="ulOne" :class="{'win':indexa===0&&prize_list.length==3}">
                        <li v-for="(item,index) in arrOne" :class="{'win':index===indexa}" :style="{ zIndex: item.zIndex,transform: item.deg }"></li>
                      </ul>
                      <ul class="ulTwo" :class="{'win':indexa===arrOne.length-1}">
                        <li v-for="(item,index) in arrTwo" :class="{'win':index===indexb}" :style="{ zIndex: item.zIndex,transform: item.deg }"></li>
                        <li v-if="prize_list.length==3" :class="{'win':indexb===0}" style="border:none;z-index:4; transform: rotate(329deg)"></li>
                      </ul>
                      <div></div>
                    </div>
                    <div class="prize-list">
                      <div class="prize-item" v-for="(item,index) in prize_list" :key="index" :style="{transform:item.troter,width:item.width}">
                        <div class="prize-pic">
                          <img :src="item.imgUrl">
                        </div>
                        <div class="prize-name zt12">
                          <!--{{item.prizeName}}-->
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>


            <div class="kitty_logo">
              <img src="@/images/bg_kitty.gif">
            </div>

            <div class="kitty_two_button">

<!--              <div class="five_button">-->
<!--                <img src="@/images/bt_5.gif">-->
<!--              </div>-->
<!--              <div class="ten_button">-->
<!--                <img src="@/images/bt_10.gif">-->
<!--              </div>-->

              <div class="five_button" @click="setGameActionContinuousPromission('FIVE_ACT')" v-if="prize_tuer5">
                <img :src="imgLin5" >
              </div>
              <div class="five_button" v-if="prize_inuer5">
                <img :src="imgLin5" >
              </div>
              <div class="ten_button"  @click="setGameActionContinuousPromission('TEN_ACT')" v-if="prize_tuer10">
                <img :src="imgLin10">
              </div>
              <div class="ten_button" v-if="prize_inuer10">
                <img :src="imgLin10">
              </div>

            </div>

            <!--没有奖品的提示-->
            <van-popup v-model="showNoProduct" class="num_popup">
              <div class="num_icon">
                <img src="@/images/balloon@3x.png">
              </div>
              <div class="num_info">
                <div style="" class="num_info_img">
                  <img src="@/images/love@3x.png">
                </div>
                <div class="num_text">
                  该奖品已被领取完成啦
                </div>
              </div>

              <div style="" @click="showNoProduct=false" class="num_close">
                <img src="@/images/close2@3x.png"/>
              </div>

            </van-popup>


            <!--没有抽奖次数的提示-->
            <van-popup v-model="showNum" class="num_popup">
              <div class="num_icon">
                <img src="@/images/balloon@3x.png">
              </div>
              <div class="num_info">
                <div style="" class="num_info_img">
                  <img src="@/images/love@3x.png">
                </div>
                <div class="num_text">
                  您今天的抽奖次数已用完 下次再来吧
                </div>
              </div>

              <div style="" @click="showNum=false" class="num_close">
                <img src="@/images/close2@3x.png"/>
              </div>

            </van-popup>

<!--            抽奖的三种状态 再次抽奖 恭喜中奖 K币不足 -->

            <!--没有中奖的提示 1-->
            <van-popup v-model="prizeNothing" class="num_popup2">
<!--              <div class="popup_shadow">-->
<!--                <img src="@/images/-s-modification_Cake@3x.png" class="no_icon">-->
<!--              </div>-->
<!--              <div style="width:100%;margin-top: 2rem; position: absolute; z-index: 2" @click="prizeNothing=false" class="num_close">-->
<!--                <img src="@/images/game_wbg_close.png" />-->
<!--              </div>-->
              <div class="no_back">
                <img src="@/images/bg_gk.png" class="bg_gk trans_xz">
                <img src="@/images/game_po3.gif" style="width: 23.45rem; position: absolute">
                <div class="no_desc">
                  很遗憾您没有中奖
                </div>
<!--                <div class="no_center">-->
<!--                  <img src="@/images/game_wbg_kt.png">-->
<!--                </div>-->
                <div class="no_right">
                  <button @click="prizeNothing=false" class="inyuer3">
                    <img src="@/images/game_wbg_again.png">
                  </button>
                </div>
              </div>
            </van-popup>

            <!--恭喜中奖了 2-->
            <van-popup v-model="prizeBox" class="num_popup2">
              <!--              <div class="popup_shadow">-->
              <!--                <img src="@/images/-s-modification_Cake@3x.png" class="no_icon">-->
              <!--              </div>-->
<!--              <div style="width:100%;margin-top: 2rem; position: absolute; z-index: 2" @click="prizeBox=false" class="num_close">-->
<!--                <img src="@/images/game_wbg_close.png" />-->
<!--              </div>-->
              <div class="no_back">
                <img src="@/images/bg_gk.png" class="bg_gk trans_xz">
                <img src="@/images/game_po1.gif" style="width: 23.45rem; position: absolute">
                <div class="no_desc_in">
                  恭喜您中奖了
                </div>

                <!--普通抽奖-->
                <div class="no_long" v-if="chou_inter">
                  <div class="no_long_kp2">
                    <img :src="headImg">
                  </div>
                </div>

                <!-- 连抽抽奖-->
                <div  v-if="chou_inmon" class="no_tuner">
                    <div class="no_long5" v-for="(item,index) in lotteryList" v-if="item.prizeNo != '0'">
                      <div class="no_long5_in" >
                        <div class="no_long_kp">
                          <img :src="item.imgUrl">
                        </div>
                      </div>
                    </div>
                </div>

                <div class="no_right2">
                  <button @click="prizeBox=false" class="inyuer1">
                    <img src="@/images/game_right_in.png">
                  </button>
                  <button @click="prizeAction()" class="inyuer2">
                    <img src="@/images/game_left_in.png">
                  </button>
                </div>
              </div>
            </van-popup>


            <!--K币不足 3-->
            <van-popup v-model="prizeBi" class="num_popup2">
              <!--              <div class="popup_shadow">-->
              <!--                <img src="@/images/-s-modification_Cake@3x.png" class="no_icon">-->
              <!--              </div>-->
<!--              <div style="width:100%;margin-top: 2rem; position: absolute; z-index: 2" @click="prizeBi=false" class="num_close">-->
<!--                <img src="@/images/game_wbg_close.png" />-->
<!--              </div>-->
              <div class="no_back">
                <img src="@/images/bg_gk.png" class="bg_gk trans_xz">
                <img src="@/images/game_po2.gif" style="width: 23.45rem; position: absolute">
                <div class="no_desc3">
                  您的K币余额不足
                  <div style="font-size: 1.15rem; margin-top: 0.5rem">是否购买卡币继续参与抽奖</div>
                </div>

                <div class="no_right3">
                  <button @click="prizeBi=false" class="inyuer_in1">
                    <img src="@/images/game_cancel.png">
                  </button>
                  <button @click="rechargeAction()" class="inyuer_in2">
                    <img src="@/images/game_qren.png">
                  </button>
                </div>
              </div>
            </van-popup>

            <!--中奖红包的提示-->
            <van-popup v-model="prizeRed" class="num_popup">
              <div class="popup_shadow">
                <img src="@/images/modification_hamburger@3x.png" style="width:1.875rem;height: 2.5em;float: right;">
              </div>
              <div style="width:100%;background-color: white;height: 15.625rem;border-radius: 0.625rem;">
                <div style="margin: 0rem 1rem 0rem 1rem;height: 3rem;background-color: white;text-align: center;padding-top: 1rem;">
                  <img src="@/images/Won the prize@3x.png" style="width:9.875rem;height: 1.4375rem;margin-top: 1rem;margin-left: 2rem;">
                </div>
                <div style="color:#EB6E8E;font-size: 0.8125rem;text-align: center;margin-top: 1rem;">
                  <img src="@/images/Red envelopes2@3x.png" style="width:3.3125rem;height: 3.8375rem;margin-top: 0.5rem;">
                  <div v-if="prizePoint == false" style="margin-top: 1.5rem;" >
                    {{hasPrize.words2}}
                  </div>
                  <div v-if="prizePoint == true" style="margin-top: 1.5rem;" >
                    {{hasPrize.words2}}
                  </div>
                </div>
                <div style="width:100%;text-align: center;margin-top: 0.5rem;">
                  <button style="width:7.5rem;height:1.875rem;text-align: center;color:white;font-size: 0.75rem;background-color: #EB6E8E;border-radius: 0.3rem;" @click="prizeRed=false">收下</button>
                </div>
              </div>

              <div @click="prizeRed=false" class="num_close">
                <img src="@/images/close2@3x.png" />
              </div>
            </van-popup>

            <!--中奖优惠券的提示-->
            <van-popup v-model="prizeCoupon" class="num_popup">
              <div class="popup_shadow">
                <img src="@/images/modification_hamburger@3x.png" style="width:1.875rem;height: 2.5em;float: right;">
              </div>
              <div style="width:100%;background-color: white;height: 13.75rem;border-radius: 0.625rem;">
                <div style="margin: 0rem 1rem 0rem 1rem;height: 3rem;background-color: white;text-align: center;padding-top: 1rem;">
                  <img src="@/images/Won the prize@3x.png" style="width:9.875rem;height: 1.4375rem;margin-top: 1rem;margin-left: 2rem;">
                </div>
                <div style="color:#EB6E8E;font-size: 0.8125rem;text-align: center;">
                  <img src="@/images/Bottom frame@3x.png" style="width:12.375rem;height: 6.9375rem;margin-top: 0.5rem;">
                  <div style="position: relative;top: -5rem;">
                    <img src="@/images/Full reduction2@3x.png" style="width:8.375rem;height:3.4375rem; "/>
                    <div style="width:1rem;position: relative;top: -3.5rem;left: 4rem;color:white;font-size: 0.75rem;">
                      优惠券
                    </div>
                    <div style="position: relative;top: -6rem;left: 6rem;width: 5rem;color:white;font-size: 0.75rem;height: 2rem;">
                      <div>
                        {{hasPrize.words2}}
                      </div>
                      <div>
                        <!--全场通用-->
                      </div>
                    </div>
                  </div>
                  <div style="text-align: center;font-size: 0.75rem;color:#EB6E8E;position: relative;top: -8.5rem;">
                    可在'个人中心'查看
                  </div>
                </div>
              </div>

              <div style="width:100%;margin-top: 2rem;" @click="prizeCoupon=false">
                <img src="@/images/close2@3x.png" style="width:1.25rem;height: 1.25rem;margin-left: 7rem;" />
              </div>

            </van-popup>

            <!--中奖实物的提示-->
            <van-popup v-model="prizeProduct" class="num_popup">
              <div class="popup_shadow">
                <img src="@/images/-s-modification_ice cream@3x.png" style="width:1.625rem;height: 2.78em;float: right;">
              </div>
              <div style="width:100%;background-color: white;height: 24.75rem;border-radius: 0.625rem;">
                <div style="margin: 0rem 1rem 0rem 1rem;height: 3rem;background-color: white;text-align: center;padding-top: 1rem;">
                  <img src="@/images/Won the prize@3x.png" style="width:9.875rem;height: 1.4375rem;margin-top: 0.5rem;margin-left: 1rem;">
                </div>
                <div style="color:#EB6E8E;font-size: 0.8125rem;text-align: center;margin-top: 0.5rem;">
                  <img src="@/images/Scene_graphics@3x.png" style="width:11.8125rem;height: 12.875rem;">
                  <div style="width:11.8125rem;text-align: center;margin: 0.5rem auto 0;">
                    <div>{{hasPrize.words1}}</div>
                    <div>{{hasPrize.words2}}</div>
                  </div>
                  <!--<div>-->
                  <!--获得了[xx]积分-->
                  <!--</div>-->
                </div>
                <div style="width:100%;text-align: center;margin-top: 0.5rem;">
                  <button style="width:7.5rem;height:1.875rem;text-align: center;color:white;font-size: 0.75rem;background-color: #EB6E8E;border-radius: 0.3rem;" @click="goAddress()">填写收货地址</button>
                </div>
              </div>
              <div @click="prizeProduct=false" class="num_close">
                <img src="@/images/close2@3x.png"/>
              </div>
            </van-popup>

            <!--中奖实物收货地址确认-->
            <van-popup v-model="prizeAddress" class="num_popup">
              <div class="popup_shadow">
                <img src="@/images/-s-modification_ice cream@3x.png" style="width:1.625rem;height: 2.78em;float: right;">
              </div>
              <div style="width:100%;background-color: white;height: 12.1875rem;border-radius: 0.625rem;">
                <div style="font-size: 0.75rem;color:#EB6E8E;font-weight: bold;padding-top: 1.8rem;width:10rem;text-align: center;margin:0 auto;line-height: 1rem;">
                  <div>
                    请确认您的地址填写无误，
                  </div>
                  <div>
                    我们会将奖品寄往以下地址：
                  </div>
                </div>
                <div style="font-size: 0.75rem;color:#EB6E8E;font-weight: bold;padding-top: 1rem;width:10rem;text-align: center;margin:0 auto;line-height: 1rem;">
                  <div>
                    {{addressInfo.province}}{{addressInfo.city}}{{addressInfo.district}}{{addressInfo.address}}
                  </div>
                  <div>
                    {{addressInfo.partyName}}
                  </div>
                  <div>
                    {{addressInfo.contactNumber}}
                  </div>
                </div>

                <div style="width:100%;text-align: center;margin-top: 0.5rem;">
                  <button style="width:6.25rem;height:1.875rem;text-align: center;color:white;font-size: 0.75rem;background-color: #EB6E8E;border-radius: 0.3rem;display: inline-block;vertical-align: top;" @click="goAddress()">填写收货地址</button>
                  <button style="width:6.25rem;height:1.875rem;text-align: center;color:white;font-size: 0.75rem;background-color: #EB6E8E;border-radius: 0.3rem;display: inline-block;vertical-align: top;" @click="prizeAddress=false;setPresentToUserAction()">确定</button>
                </div>
              </div>

              <div @click="prizeAddress=false" class="num_close">
                <img src="@/images/close2@3x.png" />
              </div>
            </van-popup>

            <!--活动规则-->
            <div>
              <!--<img src="@/images/close3@3x.png" style="width:22.5px;height: 43px;">-->
              <van-popup v-model="showRuleView" round :style="{ height: '73%' }" style="background-color: transparent; overflow: hidden">
                <div style="width:100%;background-color: white;">
                  <div style="width:21.4375rem;margin: 0 auto; background: #ffffff">
                    <div class="game_rule_lin"></div>
                    <div class="game_rule">
                      <div class="game_kin">
                        <div style="text-align: center" class="game_text_head">活动规则</div>
                        <div v-html="gameInfo" class="game_text_ter"></div>
                      </div>
                    </div>
<!--                    <div @click="showRuleView=false" style=" position: absolute; right: 0; top: 0.6rem">-->
<!--                      <img src="@/images/close_bi.png" style="width:1.5rem"/>-->
<!--                    </div>-->

<!--                    <div style="position: absolute; left: 7.5rem; bottom: 0.6rem; width: 6rem; height: 2rem; background: #999; border-radius: 0.3rem; text-align: center; line-height: 2rem; color: #FFF" @click="showRuleView=false">-->
<!--                      关闭-->
<!--                    </div>-->
                  </div>
                </div>
              </van-popup>
            </div>

            <!--开奖记录-->
          </div>
        </div>
        <div class="game_bottom" >
          <div ref="con1" :class="{anim:animate==true}">
            <div class="game_bottom_li" v-for="item in recordList">
              恭喜
              <div class="bottom_li_head">
               <img style="width: 2.5rem; height: 2.5rem;" :src="item.img" />
              </div>
              抽中
              <div class="bottom_li_cli">{{item.prizeName}}</div>
            </div>
          </div>
        </div>
      </div>
      </div>


      <!--      背景音乐-->
      <audio preload="auto" loop ref="audio" :src="bg_inMusic"></audio>
      <!--      抽奖按钮音乐-->
      <audio  ref="cj_Play" :src="cjdj_inMusic"></audio>
      <!--      游戏开始音乐-->
      <audio  ref="ks_Play" :src="ks_inMusic"></audio>
      <!--      中奖音乐-->
      <audio  ref="zj_Play" :src="zj_inMusic"></audio>
      <!--      未中奖音乐-->
      <audio  ref="wj_Play" :src="wzj_inMusic"></audio>
      <!--      K币不足音乐-->
      <audio  ref="kb_Play" :src="kb_inMusic"></audio>

    </div>
  </div>
</template>




<script>

  import Vue from 'vue';
  import { storeName,prodCatalogId,loginInfo,productRecommend,severUrl ,shareOnlineUrl,gameShareUrl,shareGameUrl} from '@/router/Constant'
  import { getUserInfo,getProductAttributes,getGameInfo,setGameAction,getPresentList,setPresentToUser,getWinRecordList,setGameActionContinuous} from '@/router/api';
  import { setStore,getStore,getQueryVariable,getCookie,setCookie ,setMiniProgramShare} from '@/utils/mUtil';
  import { NavBar,Swipe,SwipeItem,Image,Grid,Tabbar,Toast,Search,PullRefresh,Dialog,Popup,List,Cell,Lazyload} from 'vant';
  import footerView from '../common/footer';
  import loading from '@/components/page/common/loading.vue'
  import refresh from '@/components/page/common/refresh.vue'
  import vueSeamlessScroll from 'vue-seamless-scroll'
  Vue.use(Swipe);
  Vue.use(SwipeItem);
  Vue.use(Lazyload);


  export default {
    name: "gameTurntable",
    data() {
      return {
        imgLin10:'',
        imgLin5:'',
        gameActionList:[],
        gameMusicList:[],
        gameAdvList:[],
        audioUrl:require('../../../audio/bg_bg.mp3'),//背景音乐
        audio_CjUrl:require('../../../audio/choujiang.mp3'),//抽奖按钮音乐
        audio_ksUrl:require('../../../audio/yxks.mp3'),//游戏开始
        audio_zjUrl:require('../../../audio/zhongjiang.mp3'),//中奖音乐
        audio_wjUrl:require('../../../audio/wzhongjiang.mp3'),//未中奖音乐
        audio_kbUrl:require('../../../audio/keibi.mp3'),//K币不足音乐
        kb_inMusic:'',
        bg_inMusic:'',
        wzj_inMusic:'',
        zj_inMusic:'',
        cjdj_inMusic:'',
        ks_inMusic:'',
        lotteryList:[],
        chouType: '',
        showNum:false,
        gameId:this.$route.query.gameId,
        winnum: '1', //中奖的下标
        indexa: '', //中奖的下标在第一个ul下li的index下标，背景变深颜色
        indexb: '', //中奖的下标在第二个ul下li的index下标，背景变深颜色
        toast_control: false, //抽奖结果和活动规则弹出框控制器
        click_flag: true, //是否可以旋转抽奖
        start_rotating_degree: 0, //转盘初始旋转角度
        rotate_angle: 0, //转盘将要旋转的角度
        start_rotating_degree_pointer: 0, //指针初始旋转角度
        rotate_angle_pointer: 0, //指针将要旋转的度数
        rotate_transition: "", //初始化选中的过度属性控制
        rotate_transition_pointer: "transform 12s ease-in-out", //初始化指针过度属性控制
        presentList:[],
        emptyList:false,
        showListView:false,
        showRuleView:false,
        allLoaded:false,
        show:false,
        headImg:'',
        recordList:[],
        useDetail:[],
        prize_list: [

        ], //奖品列表

        arrOne: [],
        arrTwo: [],
        shopUid: '',
        userinfo: '',
        prizeinfo: {
          isGet: '',
          prizeInfos: [{
            validTime: '',
            invalidTime: '',
            type: ''
          }]
        }, //中奖优惠券或实物的信息
        hasPrize: {}, //抽奖之后弹出框信息
        gameInfo:"",
        prizeType:'',
        prizeNothing:false,
        prizeBox:false,
        prizeBi:false,
        prizeRed:false,
        prizeCoupon:false,
        prizeProduct:false,
        prizePoint:false,
        prizeAddress:false,
        showNoProduct:false,
        prize_tuer5:true,
        prize_tuer10:true,
        prize_inuer5:false,
        prize_inuer10:false,
        chou_inter:false,
        chou_inmon:false,

        addressInfo:{},
        showLoading:false,
        currentActionIndex:3,
        viewIndex:0,
        viewSize:20,
        backImgUrl:'',
        buttonImgUrl:'',
        lastClickActionCnt:0,
        isHave:false,
        showRecord:false,
        backHeight:0,
        toastDesc:'',
        rangeTime:7,
        showRecordShadow:false,
        score:'',
        Bunter5:'',
        Bunter10:'',
        prize_music:[],
        prize_adv:[],
        prize_moimg:'',
        prize_noimg:'',
        isOff:true,
        pointerLinte: true,
        pointerHent: false,
        activeIndex: 0,
        intnum: undefined,
        animate:false,
        turnImgUrl:'',
        actionPoint:[],
        Tunhref:'',
        audio:'',
        listData: [{
          'title': '周大福HelloKitty定制款1'
        },{
          'title': '周大福HelloKitty定制款2'
        },{
          'title': '周大福HelloKitty定制款3'
        },{
          'title': '周大福HelloKitty定制款4'
        },{
          'title': '周大福HelloKitty定制款5'
        },{
          'title': '周大福HelloKitty定制款6'
        },{
          'title': '周大福HelloKitty定制款7'
        },{
          'title': '周大福HelloKitty定制款8'
        },{
          'title': '周大福HelloKitty定制款9'
        },{
          'title': '周大福HelloKitty定制款10'
        },{
          'title': '周大福HelloKitty定制款11'
        },]
      }


    },

    computed: {
      optionHover () {
        return {
          hoverStop: true, //是否悬停
          singleHeight:0,  // 单行停顿
        }
      },
      isOffClass() {
        return !this.isOff ? 'isOff' : 'isOn';
      }
    },

    created() {
      setInterval(this.scroll,1000)
    },

    methods: {
      async initMont() {
        // this.getWinRecordListAction();
      },

      changeOn(){
        if(this.isOff){
          this.$refs.audio.play();//让音频文件开始播放
        }else{
          this.$refs.audio.pause()//让音频文件暂停播放
          this.$refs.cj_Play.pause();//让音频文件开始播放
          this.$refs.ks_Play.pause();//让音频文件开始播放
          this.$refs.zj_Play.pause();//让音频文件开始播放
          this.$refs.wj_Play.pause();//让音频文件开始播放
          this.$refs.kb_Play.pause();//让音频文件开始播放
        }
        this.isOff = !this.isOff;
      },

      audioAutoPlay() {
        console.log('audio:', this.$refs.audio);
        this.isOff = false;
        this.$refs.audio.play();
        this.$refs.cj_Play.pause();
        this.$refs.ks_Play.pause();
        this.$refs.zj_Play.pause();
        this.$refs.wj_Play.pause();
        this.$refs.kb_Play.pause();

        document.removeEventListener('touchstart',this.audioAutoPlay);
      },

      scroll(){
        this.animate=true;    // 因为在消息向上滚动的时候需要添加css3过渡动画，所以这里需要设置true
        setTimeout(()=>{      //  这里直接使用了es6的箭头函数，省去了处理this指向偏移问题，代码也比之前简化了很多
          this.recordList.push(this.recordList[0]);  // 将数组的第一个元素添加到数组的
          this.recordList.shift();               //删除数组的第一个元素
          this.animate=false;  // margin-top 为0 的时候取消过渡动画，实现无缝滚动
        },500)
      },

      chou(index) {
        let _this = this;
        _this.indexa = ''
        _this.indexb = ''
        // _this.winnum = Math.floor(Math.random() * Number(_this.prize_list.length - 1));
        //以前的活动序号都是从0开始的，奖品与指针不符是因为最新的活动序号都是从1开始的，序号改成从0开始的就行了  - 1

        _this.winnum = index - 1
        _this.rotating(_this.winnum)
      },

      setSan() {
        let _this = this
        _this.arrOne = [];
        _this.arrTwo = [];
        _this.rotate_angle = "rotate(" + Math.floor(-360 * 100 / _this.prize_list.length) / 200 + "deg)";
        _this.start_rotating_degree = Math.floor(-360 * 100 / _this.prize_list.length) / 200;
        for(var i = 0; i < _this.prize_list.length; i++) {
          _this.prize_list[i].troter = "rotate(" + Math.floor(360 * 100 / _this.prize_list.length) / 100 * (0.5 + Number(i)) + "deg) translateX(-50%)"
          _this.prize_list[i].width = Math.floor(3.14 * 15 / this.prize_list.length) + "rem"
          var item = {
            value: _this.prize_list[i].name,
            zIndex: Number(i) + 1,
            deg: "rotate(" + Math.floor(360 * 100 / this.prize_list.length) * i / 100 + "deg)",
            degnum: i,
          }
          if(i < _this.prize_list.length / 2) {
            _this.arrOne.push(item)
          } else {
            _this.arrTwo.push(item)
          }
        }
        this.showLoading = true
      },


      // 图片类型 五连抽十连抽
      paizeRun(){
        this.prize_inter.forEach((k,v) => {
          switch (k.actionEnumId){
            case  'TEN_ACT':
              this.imgLin10 = k.actionImage
              break;
            case  'FIVE_ACT':
              this.imgLin5 = k.actionImage
              break;
          }
        })
      },


      paize_music() {
        this.prize_music.forEach((k,v) => {
          switch (k.musicEnumId){
            // k币不足音效
            case  'POOR_MUSIC':
              this.kb_inMusic = k.musicUrl
              break;
            // 背景音乐
            case  'BG_MUSIC':
              this.bg_inMusic = k.musicUrl
              break;
            // 未中奖音效
            case  'LOSE_MUSIC':
              this.wzj_inMusic = k.musicUrl
              break;
            // 中奖音效
            case  'WIN_MUSIC':
              this.zj_inMusic = k.musicUrl
              break;
            // 点击抽奖音效
            case  'CLICK_MUSIC':
              this.cjdj_inMusic = k.musicUrl
              break;
            // 开始抽奖音效
            case  'START_MUSIC':
              this.ks_inMusic = k.musicUrl
              break;
          }
        })
      },

      rotating(index) { //转盘转动函数，index值为中奖的下标，后台会返回中奖的id，这边会首先for循环判断中奖的下标
        let _this = this;
        _this.rotate_transition = "transform 6s cubic-bezier(0.25,0.1,0.01,1)";
        // _this.rotate_transition = "transform 6s ease-in-out";
        if(!_this.click_flag) return;
        var type = 0; // 默认为 0  转盘转动 1 箭头和转盘都转动(暂且遗留)
        var during_time = 5; // 默认为1s

        var result_index = index; // 最终要旋转到哪一块，对应prize_list的下标

        var rand_circle = 6; // 附加多转几圈，2-3
        _this.click_flag = false; // 旋转结束前，不允许再次触发

        if(type == 0) {
          if(this.start_rotating_degree < 0) {
            this.start_rotating_degree = 0
          } else {
            this.start_rotating_degree = this.start_rotating_degree + Math.floor(360 * 100 / this.prize_list.length) / 200 + Math.floor(360 * 100 / this.prize_list.length) / 100 * this.lastClickActionCnt;
          }
          console.log('开始的角度===' + this.start_rotating_degree)
          var rotate_angle = this.start_rotating_degree + 360 * 10 + Math.floor(-360 * 100 / this.prize_list.length) / 200 + Math.floor(-360 * 100 / this.prize_list.length) / 100 * result_index;
          console.log('角度当前为===' + rotate_angle)
          this.lastestAngle = rotate_angle

          this.lastClickActionCnt = result_index

          this.start_rotating_degree = rotate_angle;
          _this.rotate_angle = "rotate(" + rotate_angle + "deg)";

          !this.isOff && this.$refs.audio.pause()

          // 旋转结束后，允许再次触发
          setTimeout(function() {
            _this.game_over()
            _this.rangeTime = 7
            _this.click_flag = true;

            _this.pointerLinte = true
            _this.pointerHent = false

            _this.prize_tuer5 = true
            _this.prize_inuer5 = false

            _this.prize_tuer10 = true
            _this.prize_inuer10 = false

            if(_this.winnum < _this.prize_list.length / 2) {
              _this.indexb = ''
              _this.indexa = _this.winnum;
            } else {
              _this.indexa = ''
              _this.indexb = _this.winnum - (_this.arrOne.length);
            }
            setTimeout(function() {
              // _this.toast_control = true
            }, 100)

          }, during_time * 1000 + 1500); // 延时，保证转盘转完
        }

        //this.setGameClick()
      },



      game_over() {
        let _this = this;
        _this.prizetype = 1
        if(_this.prizetype != -1) {
          _this.toast_control = true;
        } else {
          _this.showNoProduct = true
          //Alert.show("奖品已领完，下次请早到哦！")
        }
        var obj = {}

        // 针对多次抽奖的
        console.log(this.chouType);
        if (this.chouType !== '') {
          let isSuccess = this.lotteryList.some(item => parseInt(item.prizeNo) !== 0)
          if(isSuccess) {
            this.prizeBox = true
            !this.isOff && this.$refs.zj_Play.play()
            setTimeout(function() {
              console.log("多次抽奖音频")
              !_this.isOff && _this.$refs.audio.play();
            }, 1000);

          } else {
            this.prizeNothing = true
            !this.isOff && this.$refs.wj_Play.play()
            setTimeout(function() {
              console.log("多次抽奖音频")
              !_this.isOff && _this.$refs.audio.play();
            }, 1000);
          }


          return
        }

        // 针对一次抽奖的
        for(var i = 0;i<_this.prize_list.length;i++){
          if(_this.prize_list[i].prizeNo==_this.winnum){
            if(_this.prize_list[i].prizeType == 'NOTHING') {
              obj = {}
              this.prizeNothing = true
              !this.isOff && this.$refs.wj_Play.play()

              setTimeout(function() {
                console.log("NOTHING")
                !_this.isOff && _this.$refs.audio.play();
              }, 1000);


            } else if(_this.prize_list[i].prizeType == 'COUPON') {
              obj = {
                words2:  _this.prize_list[i].prizeName,
              }
              this.prizeBox = true
              !this.isOff && this.$refs.zj_Play.play()
              setTimeout(function() {
                console.log("COUPON")
                !_this.isOff && _this.$refs.audio.play();
              }, 1000);
            } else if(_this.prize_list[i].prizeType == 'PRODUCT') {
              obj = {
                type: 1,
                words1: '获得'+_this.prize_list[i].prizeNoName,
                words2:  _this.prize_list[i].prizeName,
              }
              this.prizeBox = true
              !this.isOff && this.$refs.zj_Play.play()
              setTimeout(function() {
                console.log("PRODUCT")
                !_this.isOff && _this.$refs.audio.play();
              }, 1000);
            } else if(_this.prize_list[i].prizeType == 'BONUS') {
              obj = {
                type: 1,
                words2: "获得" + _this.prize_list[i].prizeName,
              }
              this.prizeBox = true
              !this.isOff && this.$refs.zj_Play.play()
              setTimeout(function() {
                console.log("BONUS")
                !_this.isOff && _this.$refs.audio.play();
              }, 1000);
            }else if(_this.prize_list[i].prizeType == 'POINT') {
              obj = {
                type: 1,
                words2: "获得" + _this.prize_list[i].prizeName,
              }
              this.prizeBox = true
              !this.isOff && this.$refs.zj_Play.play()
              setTimeout(function() {
                console.log("POINT")
                !_this.isOff && _this.$refs.audio.play();
              }, 1000);
            } else{
              obj = {
                type: 1,
                words2: "获得" + _this.prize_list[i].prizeName,
              }
              this.prizeBox = true
              !this.isOff && this.$refs.zj_Play.play()
              setTimeout(function() {
                console.log("获得")
                !_this.isOff && _this.$refs.audio.play();
              }, 1000);
            }
            _this.hasPrize = obj
            return
          }
        }
      },

      initData(){
        if(getStore('gameAddress')!=''&&getStore('gameAddress')!=undefined&&getStore('gameAddress')!=null){
          this.addressInfo = JSON.parse(getStore('gameAddress'))
          this.prizeAddress = true
          setStore('gameAddress','')
        }else{
          this.prizeAddress = false
        }
        this.getGameInfoAction();
      },

      // 获取游戏详情
      getGameInfoAction(){
        getGameInfo({externalLoginKey:getStore('externalLoginKey'),channel:getStore('channel'),openId:getStore('openId'),unionId:getStore('unionId'),gameId:this.gameId})
          .then(res => {
            console.log('getGameInfo')
            console.log(res)
            if (res._ERROR_MESSAGE_) {
              // Toast(res._ERROR_MESSAGE_)
              this.showLoading = true
              this.isHave = true
              if(res._ERROR_MESSAGE_){
                this.toastDesc = res._ERROR_MESSAGE_
              }
              // if(res._ERROR_MESSAGE_.indexOf('不在发布范围内')!=-1){
              //   this.toastDesc = '抱歉，您无法参与此活动'
              // }else{
              //   this.toastDesc = '暂无游戏活动'
              // }
            } else {
              this.isHave = false
              this.prize_list = res.gameProductList
              this.useDetail = res.useDetail
              this.gameInfo = res.gameInfo
              this.isUsePoint = res.isUsePoint
              this.currentActionIndex = res.useDetail.surplusCount
              this.backImgUrl = res.imgUrl
              this.buttonImgUrl = res.buttonImgUrl
              this.score = res.pointCount

              // this.Bunter = res.gameActionList[0].actionPoint
              // this.Bunter = res.gameActionList[1].actionPoint

              this.Bunter5 = res.gameActionList[0].actionPoint
              this.Bunter10 = res.gameActionList[1].actionPoint

              this.turnImgUrl = res.turnImgUrl
              this.recordList = res.recordList
              this.prize_imgleft = res.prize_imgleft
              this.prize_music = res.gameMusicList
              this.prize_inter = res.gameActionList
              this.prize_adv = res.gameAdvList
              this.prize_moimg = res.recordImgUrl
              this.prize_noimg = res.ruleImgUrl


              document.title = res.gameName
              setMiniProgramShare(res.gameName,'',gameShareUrl+encodeURIComponent(shareGameUrl+'gameTurnTable')+'&gameId='+this.gameId)
              if (getStore('currentGameAddress')!=undefined&&getStore('currentGameAddress')!='') {
                this.showToast = true
                this.index = getStore('gamePrize')
                this.showAddressView = true;
                this.currentGameAddressDetail = getStore('currentGameAddressDetail')
              } else {
                this.showAddressView = false;
              }
              this.setSan()
              this.paizeRun()
              this.paize_music()
            }
          })

          .catch(err => {
            console.log(err);
          });
      },

      setGameClick(){
        if(this.rangeTime!=0){
          if (this.currentActionIndex > 0) {
            this.rangeTime = 0
            this.setGameAction()
          } else {
            this.showNum = true
            // Toast.fail('你今日抽奖次数已用完，请下次再来')

          }
        }else{
        }
      },

      dialogAction(msg){
        Dialog.confirm({
          message: msg
        }).then(() => {
          // window.location.href = loginUrl
          // wx.miniProgram.navigateTo({url:'../../pages/webviewLogin/webviewLogin?gameId=' + this.$route.query.gameId})
          if (getStore('fromType')=='mini') {
            wx.miniProgram.navigateTo({url:'../../pages/webviewLogin/webviewLogin?gameId=' + this.$route.query.gameId,})
          } else {
            wx.miniProgram.switchTab({url:'../../pages/menu/menu'})
          }
        }).catch(() => {

        });
      },


      setClickActionPromission(){
        // debugger
        this.pointerLinte = false
        this.pointerHent = true
        this.prize_tuer5 = false
        this.prize_inuer5 = true
        this.prize_tuer10 = false
        this.prize_inuer10 = true
        // 普通抽奖显示
        this.chou_inter = true
        this.chou_inmon = false

        this.chouType = ''

        console.log("getStore('islogIn')=================" + getStore('islogIn'))
        if (getStore('islogIn')=='true') {
          if(this.useDetail.freeCount > 0) {
            this.setGameActionFunction();
          } else {
            if (this.isUsePoint === "Y") {
              if (this.useDetail.pointAccountNum > 0 && this.useDetail.pointAccountNum >= this.score) {
                this.setGameActionFunction();
              } else{
                // k币余额不足  提示并去充值
                this.prizeBi = true;
                !this.isOff && this.$refs.kb_Play.play()
                this.pointerLinte = true
                this.pointerHent = false

                this.prize_tuer5 = true
                this.prize_inuer5 = false

                this.prize_tuer10 = true
                this.prize_inuer10 = false

              }
            } else {
              // 不能使用k币 抽奖
              Toast("抱歉，不能使用k币");
            }
          }
        } else {
        // 当前还未登录 跳转到小程序去登录
          this.pointerLinte = true
          this.pointerHent = false

          this.prize_tuer5 = true
          this.prize_inuer5 = false

          this.prize_tuer10 = true
          this.prize_inuer10 = false

          this.dialogAction('当前还未登录，是否去登录？')
      }
      },


      // 用户点击抽奖
      setGameActionFunction(){
        let _this = this
        !this.isOff && this.$refs.cj_Play.play()
        setGameAction({externalLoginKey:getStore('externalLoginKey'),channel:getStore('channel'),openId:getStore('openId'),unionId:getStore('unionId'),gameId:_this.gameId})
          .then(res => {
            console.log('setGameAction')
            !this.isOff && this.$refs.ks_Play.play()
            console.log(res)

            if (!res._ERROR_MESSAGE_) {
              _this.index = res.prizeNo
              _this.winnum = res.prizeNo
              this.currentActionIndex = res.surplusCount
              this.headImg = res.imgUrl
              setStore('lotteryRecordId',res.lotteryRecordId)
              _this.chou(res.prizeNo)
              this.$set(this.useDetail, 'freeCount', res.freeCount)
              this.$set(this.useDetail, 'pointAccountNum', res.pointAccountNum)
            } else {
              Toast.fail({
                duration: 3000,
                message: res._ERROR_MESSAGE_,
              })
              setTimeout(() => {
                this.pointerLinte = true
                this.pointerHent = false


                this.prize_tuer5 = true
                this.prize_inuer5 = false

                this.prize_tuer10 = true
                this.prize_inuer10 = false

              }, 3000);
            }

          })
          .catch(err => {
            console.log(err);
          });
      },


      // 用户连抽点击事件
      setGameActionContinuousPromission(type){
        // debugger
        this.pointerLinte = false
        this.pointerHent = true

        this.prize_tuer5 = false
        this.prize_inuer5 = true

        this.prize_tuer10 = false
        this.prize_inuer10 = true

        // 连抽抽奖显示
        this.chou_inter = false
        this.chou_inmon = true

        this.chouType = type;

        console.log("getStore('islogIn')=================" + getStore('islogIn'))
        if (getStore('islogIn')=='true') {

          if (this.isUsePoint === "Y") {
            if ((this.chouType === 'FIVE_ACT' && this.useDetail.pointAccountNum >= this.Bunter5) || (this.chouType === 'TEN_ACT' && this.useDetail.pointAccountNum >= this.Bunter10)) {
              this.setGameActionContinuousFunction();
            } else {
              // k币余额不足  提示并去充值
              this.prizeBi = true;
              !this.isOff && this.$refs.kb_Play.play()
              this.pointerLinte = true
              this.pointerHent = false

              this.prize_tuer5 = true
              this.prize_inuer5 = false

              this.prize_tuer10 = true
              this.prize_inuer10 = false
            }
          } else {
            // 不能使用k币 抽奖
            Toast("抱歉，不能使用k币");
          }

          // if(this.useDetail.freeCount > 0) {
          //   this.setGameActionContinuousFunction();
          // } else {
          //
          // }
        } else {
          // 当前还未登录 跳转到小程序去登录
          this.pointerLinte = true
          this.pointerHent = false

          this.prize_tuer5 = true
          this.prize_inuer5 = false

          this.prize_tuer10 = true
          this.prize_inuer10 = false
          this.dialogAction('当前还未登录，是否去登录？')
        }
      },

      // 连抽的接口事件
      setGameActionContinuousFunction(){
        let _this = this
        !this.isOff && this.$refs.cj_Play.play()
        setGameActionContinuous({
          externalLoginKey:getStore('externalLoginKey'),
          channel:getStore('channel'),
          openId:getStore('openId'),
          unionId:getStore('unionId'),
          actionEnumId:this.chouType,
          gameId:_this.gameId
        })
          .then(res => {
            console.log('setGameActionContinuous')
            !this.isOff && this.$refs.ks_Play.play()
            console.log(res)

            if (!res._ERROR_MESSAGE_) {
              _this.index = res.lotteryList[res.lotteryList.length - 1].prizeNo
              // _this.winnum = res.lotteryList[res.lotteryList.length - 1].prizeNo
              this.lotteryList = res.lotteryList
              this.currentActionIndex = res.surplusCount
              this.headImg = res.imgUrl
              setStore('lotteryRecordId',res.lotteryRecordId)
              _this.chou(_this.index)
              this.$set(this.useDetail, 'freeCount', res.freeCount)
              this.$set(this.useDetail, 'pointAccountNum', res.pointAccountNum)
            } else {
              Toast.fail({
                duration: 3000,
                message: res._ERROR_MESSAGE_,
              })
              setTimeout(() => {
                this.pointerLinte = true
                this.pointerHent = false

                this.prize_tuer5 = true
                this.prize_inuer5 = false

                this.prize_tuer10 = true
                this.prize_inuer10 = false

              }, 3000);
            }

          })
          .catch(err => {
            console.log(err);
          });
      },


      // 获取中奖名单列表
      getWinRecordListAction(){
        var param = {
          externalLoginKey:getStore('externalLoginKey'),
          openId:getStore('openId'),
          unionId:getStore('unionId'),
          gameId:this.gameId,
          name:this.name,
          time: this.time,
          prizeName:this.prizeName,
          img:this.img,
        }
        // console.log(param)

        getWinRecordList(param)
          .then(res => {
            console.log('getWinRecordList')
            console.log(res)
            this.recordList = res.recordList

          })
          .catch(err => {
            Toast.fail(err);
          });
      },

      prizeAction(){
        if (getStore('islogIn')=='true') {
          this.$router.push({path:'/gamePrize',query:{externalLoginKey:getStore('externalLoginKey')}})
        } else {
          this.dialogAction('当前还未登录，是否去登录？')
        }
      },
      rechargeAction(){
        // this.$router.push({path:'/buyCard',query:{gameId:this.gameId}})
        // 上传正式的时候需要修改 severUrl
        window.location.href = severUrl + "/card/#/buyCard?externalLoginKey=" + getStore('externalLoginKey')
      },

      //上拉加载
      loadMore() {
        if (!this.allLoaded) {
          this.viewIndex ++;
          getPresentList({externalLoginKey:getStore('externalLoginKey'),openId:getStore('openId'),unionId:getStore('unionId'),gameId:this.gameId,viewIndex:this.viewIndex,viewSize: this.viewSize})
            .then(res => {
              if (res.presentList) {
                this.show = true
                if (res.presentList.length && res.presentList.length < this.viewSize) {
                  this.allLoaded = true
                } else {
                  this.allLoaded = false
                }
                var oldProductList = this.presentList
                var newProductList = oldProductList.concat(res.presentList)
                this.presentList = newProductList
                this.viewIndex = res.viewIndex;
              } else {
                Toast("没有更多了");
              }
            })
            .catch(err => {
              console.log(err);
            });
        }
      },

      getPresentClickStr(item){
        var str = ""
        switch (item.prizeType) {
          case 'PRODUCT':
            if (getStore('currentGameAddress')!=undefined&&getStore('currentGameAddress')!='') {
              str = '确认'
            } else {
              str = '选择收货地址'
            }
            break
          case 'BONUS':
            str = '开心收下'
            break
          case 'POINT':
            str = '开心收下'
            break
          case 'COUPON':
            str = '开心收下'
            break
          case '':
            str = '再接在励'
            break
          default:
            str = '再接在励'
        }
        return str
      },

      // 中奖产品绑定用户
      setPresentToUserAction(){
        let _this = this;
        var addressId ;
        if(this.addressInfo.contactMechId!=undefined&&this.addressInfo.contactMechId!=''&&this.addressInfo.contactMechId!=null){
          addressId = this.addressInfo.contactMechId
        }else{
          addressId = ''
        }
        var param = {
          externalLoginKey:getStore('externalLoginKey'),
          addressId:addressId,
          lotteryRecordId:getStore('lotteryRecordId')
        }
        setPresentToUser(param)
          .then(res => {
            console.log('setPresentToUser')
            console.log(res)
            if(!res._ERROR_MESSAGE_) {
              setStore('currentGameAddressDetail','')
              setStore('currentGameAddress','')

            } else {
              Toast.fail(res._ERROR_MESSAGE_)
            }
          })

          .catch(err => {
            Toast.fail(err);
          });
      },

      dateFormat (fmt, date) {
        let ret;
        let opt = {
          "y+": date.getFullYear().toString(),        // 年
          "M+": (date.getMonth() + 1).toString(),     // 月
          "d+": date.getDate().toString(),            // 日
          // 有其他格式化字符需求可以继续添加，必须转化成字符串
          'h+': date.getHours().toString(),
          'm+': date.getMinutes().toString(),
          's+': date.getSeconds().toString(),
        };
        for (let k in opt) {
          ret = new RegExp("(" + k + ")").exec(fmt);
          if (ret) {
            fmt = fmt.replace(ret[1], (ret[1].length == 1) ? (opt[k]) : (opt[k].padStart(ret[1].length, "0")))
          };
        };
        return fmt;
      },

      goAddress:function () {
        this.$router.push({name:'addressList',query:{fromUrl:'game'}})
      },
    },


    components: {
      [NavBar.name]: NavBar,
      [Swipe.name]: Swipe,
      [SwipeItem.name]: SwipeItem,
      [Image.name]: Image,
      [Image.name]: Image,

      [Grid.name]: Grid,
      [Tabbar.name]: Tabbar,
      [Toast.name]: Toast,
      [Search.name]: Search,
      [PullRefresh.name]: PullRefresh,
      [Dialog.name]: Dialog,
      [Popup.name]: Popup,
      [List.name]: List,
      [Cell.name]: Cell,
      [Lazyload.name]: Lazyload,

      footerView,
      loading,
      refresh,
      vueSeamlessScroll,
      Vue,

    },

    mounted() {
      // let _this = this;
      // _this.setSan()
      this.initData();
      this.initMont();


    },

    beforeDestroy(){
      this.isShowSearch = false;
      document.querySelector('body').removeAttribute('style')
    },

    watch: {
      showLoading(value) {
        if(value) {
          this.$nextTick(() => {
            this.audioAutoPlay('audio');
            // 自动播放音乐效果，解决微信自动播放问题
            document.addEventListener('touchstart',this.audioAutoPlay,false);
            document.addEventListener('WeixinJSBridgeReady', this.audioAutoPlay,false);
            let oAudio = this.$refs.audio;
            oAudio.onended = () => {//播放完毕，重新循环播放
              oAudio.load();
              oAudio.play();
            }
          })
        }
      }
    },

  }

</script>


<style scoped>
  *{ margin: 0; padding: 0}

  .content .conts {

  }
  .content .conts .activitytime {
    height: 0.5rem;
    width: 100%;
    position: absolute;
    top: 0;
    margin: 0 auto;

  }
  .content .conts .activitytime .timebg {
    width: 100%;
    height: 100%;
    background: #000000;
    opacity: 0.3;
    position: absolute;
    left: 0;
    top: 0;
  }
  .content .conts .activitytime .time {
    color: #ffffff;
    line-height: 0.5rem;
    padding-left: 0.2rem;
    font-size: 0.24rem;
    position: relative;
    z-index: 2;
  }
  .content .conts .rule {
    height: 0.69rem;
    margin-bottom: 2.37rem;
    position: relative;
  }
  .content .conts .rule .ruletop {
    width: 1.35rem;
    height: 0.46rem;
    position: absolute;
    right: 0;
    bottom: 3px;
  }
  .content .conts .rule .ruletop .rulebg {
    height: 100%;
    width: 100%;
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    background: #1201d5;
    opacity: 0.3;
    border-top-left-radius: 0.23rem;
    border-bottom-left-radius: 0.23rem;
  }
  .content .conts .rule .ruletop .ruletitle {
    text-align: center;
    line-height: 0.46rem;
    font-size: 0.24rem;
    color: #fff;
    position: relative;
    z-index: 3;
    border-top-left-radius: 0.23rem;
    border-bottom-left-radius: 0.23rem;
    border-bottom: 3px solid #1201d5;
  }
  .content .conts .title {
    height: 0.46rem;
    text-align: center;
    color: #464ff4;
    font-size: 0.28rem;
    line-height: 0.46rem;
    font-weight: 700;
    margin-bottom: 0.24rem;
  }
  .content .conts .box {
    width: 100%;
    height: 27.5rem;
    margin: auto;
    position: relative;
    overflow: hidden;
  }
  .content .conts .box .pointer {
    width: 3.9375rem;
    height: 4.625rem;
    position: absolute;
    top: 11rem;
    left: 11.75rem;
    z-index: 20;
    transform: translate(-50%, -55%);
    /*transition:0.4s ease-in-out;*/
    /*background: url(../../../assets/img/pointer.png) top center no-repeat;*/
    background-size: 100%;
  }
  .content .conts .box .pointer p {
    color: #ff4027;
    text-align: center;
  }
  .content .conts .box .pointer p:first-of-type {
    margin-top: 1.3rem;
  }

  .boxbg_ing {
    /*width: 20rem;*/
    /*height: 20rem;*/
    width: 22.68rem;
    height: 24.43rem;
    /*background: url(../../../images/boxCircle.png) top center no-repeat;*/
    /*background-size: 100%;*/
    /*padding: 1.54rem;*/
    margin: 0 auto
  }

  .content .conts .box .boxbg {
    /*width: 20rem;*/
    /*height: 20rem;*/
    width: 22.68rem;
    height: 24.43rem;
    /*background: url(../../../images/boxCircle.png) top center no-repeat;*/
    /*background-size: 100%;*/
    /*padding: 1.54rem;*/
    margin: 0 auto;
    position: absolute;
    top: 0;
    left: 0;
  }
  .content .conts .box .boxbg .turn {
    border-radius: 50%;
    overflow: hidden;
  }
  .content .conts .box .boxbg .turn .slice {
    box-sizing: border-box;
    border: 1px solid #ffd8ad;
  }
  .content .conts .box .boxbg .turn .win {
    background: linear-gradient(top right, white 50%, #eb7aa0 100%) !important;
  }
  .content .conts .box .boxbg .turn .wheel-bg6 {
    width: 100%;
    height: 100%;
    position: relative;
  }
  .content .conts .box .boxbg .turn .wheel-bg6 div {
    text-align: center;
  }
  .content .conts .box .boxbg .turn .wheel-bg6 .prize-list {
    width: 100%;
    height: 100%;
    position: absolute;
  }
  .content .conts .box .boxbg .turn .wheel-bg6 .prize-list ul {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    border-radius: 50%;
    overflow: hidden;
    margin: 0;
    padding: 0;
  }
  .content .conts .box .boxbg .turn .wheel-bg6 .prize-list ul li {
    position: absolute;
    top: 0px;
    left: 50%;
    width: 50%;
    height: 50%;
    transform-origin: 0 100%;
    overflow: hidden;
    cursor: pointer;
    box-sizing: border-box;
    border-left: 1px solid #FFF;
    background: #FFF;
  }
  .content .conts .box .boxbg .turn .wheel-bg6 .prize-list .ulOne {
    clip: rect(0, 15rem, 15rem, 2.5rem);
  }

  .content .conts .box .boxbg .turn .wheel-bg6 .prize-list .ulOne li:nth-child(odd) {
    background: #fef7de;
  }

  .content .conts .box .boxbg .turn .wheel-bg6 .prize-list .ulTwo {
    clip: rect(0, 7.5rem, 15rem, 0);
  }

  .content .conts .box .boxbg .turn .wheel-bg6 .prize-list .ulTwo li:nth-child(even) {
    background: #fef7de;
  }
  .content .conts .box .boxbg .turn .wheel-bg6 .prize-list .prize-item {
    position: absolute;
    top: 0;
    z-index: 12;
    height: 7.5rem;
    left: 50%;
    transform: translateX(-50%);
    transform-origin: 0 100%;
  }
  .content .conts .box .boxbg .turn .wheel-bg6 .prize-list .prize-item .prize-pic {
    padding-top: 1rem;
    text-align: center;
  }
  .content .conts .box .boxbg .turn .wheel-bg6 .prize-list .prize-item .prize-pic img {
    width: 2.5rem;
    height: 2.5rem;
  }
  .content .conts .box .boxbg .turn .wheel-bg6 .prize-list .prize-item .prize-name {
    color: pink;
    font-weight: bold;

  }
  .content .conts .box .money {
    position: absolute;
    width: 0.57rem;
    height: 0.55rem;
    top: 2.17rem;
    right: -0.2rem;
  }
  .content .conts .prizebox {
    margin: 0.3rem;
    position: relative;
    border-radius: 4px;
    overflow: hidden;
    padding: 0 0.27rem 0.28rem;
  }
  .content .conts .prizebox .prizebg {
    position: absolute;
    border-radius: 4px;
    background: #fff;
    height: 100%;
    width: 100%;
    top: 0;
    left: 0;
    opacity: 0.2;
  }
  .content .conts .prizebox .pri .titname {
    color: #fff;
    font-size: 0.32rem;
    text-align: center;
    margin: 0.07rem;
  }
  .content .conts .prizebox .pri .titname span img {
    width: 1.51rem;
    height: 0.14rem;
    margin: 0 0.2rem 0.03rem;
  }
  .content .conts .prizebox .pri .titname .xuanz img {
    transform: rotate(180deg);
  }
  .content .conts .prizebox .pri .prizez {
    width: 100%;
    border: 1px solid #fa54a7;
    border-radius: 4px;
    background: #fff;
    display: flex;
  }
  .content .conts .prizebox .pri .prizez .couponleft {
    padding-left: 0.3rem;
    width: 3.9rem;
    position: relative;
    height: 100%;
  }
  .content .conts .prizebox .pri .prizez .couponleft .iconright div {
    line-height: 1.1;
  }
  .content .conts .prizebox .pri .prizez .couponleft .iconright .couponname {
    font-size: 0.32rem;
    color: #333333;
    margin: 0.45rem 0 0.2rem;
  }
  .content .conts .prizebox .pri .prizez .couponleft .iconright .timevalidity {
    font-size: 0.24rem;
    color: #999999;
    margin-bottom: 0.2rem;
  }
  .content .conts .prizebox .pri .prizez .couponleft .iconright .timevalidity:last-of-type {
    margin-bottom: 0.45rem;
  }
  .content .conts .prizebox .pri .prizez .couponright {
    flex: 1;
    line-height: 1.2rem;
    text-align: center;
    font-size: 0.24rem;
    color: #ff4745;
    vertical-align: top;
    position: relative;
  }
  .content .conts .prizebox .pri .prizez .couponright .money {
    position: relative;
    bottom: 0.02rem;
    margin-right: 0.02rem;
  }
  .content .conts .prizebox .pri .prizez .couponright .moneynum {
    font-size: 0.5rem;
  }
  .content .conts .prizebox .pri .prizez .couponright a {
    position: absolute;
    left: 0;
    right: 0;
    bottom: 0.3rem;
    width: 1.5rem;
    height: 0.54rem;
    color: #fff;
    background: #ff4745;
    border-radius: 2px;
    line-height: 0.54rem;
    text-align: center;
    font-size: 0.28rem;
    margin: auto;
    display: block;
  }
  .content .conts .prizebox .pri .prizez .couponright .tel {
    bottom: 0;
    top: 0;
  }
  .content .conts .prizebox .pri .prizez .couponright div {
    position: absolute;
    right: -0.2rem;
    top: 0;
    bottom: 0;
    margin: auto;
    width: 1.28rem;
    height: 1.28rem;
  }
  .content .conts .prizebox .pri .prizez .couponright div img {
    width: 100%;
    height: 100%;
  }
  .content .popup {
    width: 100%;
    height: 100%;
    position: fixed;
    z-index: 30;
    top: 0;
    left: 0;
  }
  .content .popup .popbg {
    width: 100%;
    height: 100%;
    background: #000;
    opacity: 0.7;
  }
  .content .popup .popbox {
    width: 15rem;
    height: 13rem;
    position: absolute;
    top: 27%;
    left: 0;
    right: 0;
    margin: auto;
    /*background: url(../../../assets/img/giftboxbg.png) top center no-repeat;*/
    background-size: 100%;
    text-align: center;
  }
  .content .popup .popbox .img {
    width: 3.06rem;
    height: 1.4rem;
    margin: auto;
    margin-top: 1.07rem;
    margin-left: 1.1rem;
    /*background: url(../../../assets/img/gift.png) top center no-repeat;*/
    background-size: 100%;
  }
  .content .popup .popbox .img1 {
    background: url(../../../assets/img/regret.png) top center no-repeat;
    background-size: 100%;
  }
  .content .popup .popbox .words1 {
    color: #d4237a;
    margin-top: 0.2rem;
  }
  .content .popup .popbox .words2 {
    color: #d4237a;
  }
  .content .popup .popbox .words3 {
    color: #999999;
    margin-top: 0.07rem;
  }
  .content .popup .activityrule {
    width: 5.54rem;
    height: 6.32rem;
    position: absolute;
    top: 20%;
    left: 0;
    right: 0;
    margin: auto;
    background: url(../../../assets/img/rulebg.png) top center no-repeat;
    background-size: 100%;
  }
  .content .popup .activityrule .rulecnt {
    padding: 1.3rem 0.77rem 0;
  }
  .content .popup .activityrule .rulecnt p {
    font-size: 0.24rem;
    line-height: 0.4rem;
    text-align: justify;
    color: #333333;
  }
  .content .popup .activityrule .rulecnt p:last-of-type {
    color: #ff4928;
  }
  .content .popup .close {
    width: 3rem;
    height: 3rem;
    background: url(../../../assets/img/close.png) top center no-repeat;
    background-size: 100%;
    position: absolute;
    top: 75%;
    left: 0;
    right: 0;
    margin: auto;
  }
  .mask{width:100%;height:100%;background:rgba(0,0,0,.7);position:fixed;overflow:hidden;z-index:222;top:0;left:0}
  .lottery-alert{max-width:400px;text-align:center;z-index:10000;border-radius:10px;background:#fff;padding:20px;position:fixed;left:0;right:0;margin:auto;top:50%;transform:translateY(-50%)}
  .lottery-alert h1{font-size:18px;font-weight:700;color:#d92b2f}
  .lottery-alert img{display:block;height:120px;margin:0 auto}
  .lottery-alert h2{font-weight:400;color:#d92b2f;font-size:15px;padding-top:15px}
  .lottery-alert p{color:#666;font-size:16px;padding-top:5px}
  .lottery-alert .btnsave{border-radius:3px;box-shadow:none;height:40px;cursor:pointer;line-height:40px;color:#fff;margin-top:12px;background:linear-gradient(180deg,rgba(213,60,63,1) 0%,rgba(201,20,24,1) 100%);font-size:16px}

  .router-slid-enter-active, .router-slid-leave-active {
    transition: all .4s;
  }
  .router-slid-enter, .router-slid-leave-active {
    transform: translate3d(2rem, 0, 0);
    opacity: 0;
  }
  .pink_back{
    width: 22.4375rem;
    /*height: 13.0625rem;*/
    /*background: url(../../../images/bottomFrame2@3x.png) top center no-repeat;*/
    /*background-size: 100%;*/
    position: absolute;

  }

  .num_popup{
    width:15rem;
    border-radius: 0.625rem;
    background-color: transparent
  }
  .num_popup2{
    width: 100%;
    height: 100%;
    border-radius: 0.625rem;
    background-color: transparent;
    position: absolute;
    top: 8rem;
    overflow: hidden;
  }
  .num_icon{
    height: 2rem;
    background-color: transparent;
  }
  .num_icon img{
    width:3.93rem;
    height: 4.06rem;
    float: right;
  }
  .num_info{
    width:100%;
    background-color: white;
    height: 7.5rem;
    border-radius: 0.625rem;
  }
  .num_info_img{
    margin: 0rem 1rem 0rem 1rem;
    height: 3rem;
    background-color: white;
  }
  .num_info_img img{
    width:2rem;
    height: 2rem;
    float: left;
    margin-top: 1rem;
  }
  .num_text{
    color:#EB6E8E;
    font-size: 0.8125rem;
    width:9.375rem;
    margin:0 auto;
    text-align: center;
  }
  .num_close{
    width:100%;
    margin-top: 2rem;
  }
  .num_close img{
    width:1.25rem;
    height: 1.25rem;
    position: absolute;
    right: 3rem;
  }
  .popup_shadow{
    height: 1rem;
    background-color: transparent;
  }
  .no_icon{
    width:1.75rem;
    height: 1.75rem;
    float: right;
  }
  .no_back{
    width:100%;
    /*background-color: white;*/
    height: 26.1rem;
    /*border-radius: 0.625rem;*/
  }
  .no_desc{
    position: absolute;
    top: 16rem;
    left: 5rem;
    width: 13rem;
    text-align: center;
    font-size: 1.4rem;
    color: #e38e20;
    padding-top: 0.5rem;
  }

  .no_desc_in{
    position: absolute;
    top: 13.5rem;
    left: 5rem;
    width: 13rem;
    text-align: center;
    font-size: 1.4rem;
    color: #e38e20;
    padding-top: 0.5rem;
  }

  .no_desc3{
    position: absolute;
    top: 15rem;
    left: 4rem;
    width: 15rem;
    text-align: center;
    font-size: 1.4rem;
    color: #e38e20;
    padding-top: 0.5rem;
  }
  .no_desc img{
    margin-top: 1rem;
  }
  .no_center{
    width: 23.45rem;
    display: flex;
    justify-content: center;
    position: absolute;
    top: 17rem;
  }

  .no_long{
    width: 23.45rem;
    display: flex;
    justify-content: center;
    position: absolute;
    top: 17rem;
  }

  .no_long5{
    width: 2.6rem; height: 2.6rem;
    position: relative;
    /*top: 16rem;*/
    /*left: 4rem;*/
    display: flex;
    flex-wrap: wrap;
    justify-content: space-around;
    align-items: center;
    margin: 0.2rem;
  }

  .no_tuner{
    width: 15rem;
    height: 6.2rem;
    position: absolute;
    top: 15.8rem;
    left: 4rem;
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    align-items: center;
  }

  .no_long10{
    width: 23.45rem;
    display: flex;
    justify-content: center;
    position: absolute;
    top: 17rem;
  }

  .no_center img{
    width: 3.5rem;
    height: 4rem;
    /*width:9.5625rem;*/
    /*height: 7.6875rem;*/
    /*margin-top: 0.5rem;*/
  }
  .no_right{
    width: 100%;
    text-align: center;
    /* margin-top: 0.5rem; */
    position: absolute;
    top: 22.5rem;
  }
  .no_right2{
    width: 17.1rem;
    height: 2.15rem;
    position: absolute;
    top: 22.5rem;
    left: 3rem;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .no_right3{
    width: 17.1rem;
    height: 2.15rem;
    position: absolute;
    top: 22.5rem;
    left: 3rem;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .no_right button{
    width:7.5rem;
    height:3rem;
    text-align: center;
    color:white;
    font-size: 0.75rem;
    /*background-color: #EB6E8E;*/
    border-radius: 0.3rem;
  }
  .inyuer1{
    width: 5.75rem;
    height: 2.84rem;
    position: absolute;
    left: 2rem;
  }
  .inyuer2{
    width: 5.75rem;
    height: 2.84rem;
    position: absolute;
    right: 1.9rem;
  }

  .inyuer3{
    width: 5.75rem;
    height: 2.84rem;
  }


  .inyuer_in1{
    width: 5.75rem;
    height: 2.84rem;
    position: absolute;
    left: 2rem;
  }
  .inyuer_in2{
    width: 5.75rem;
    height: 2.84rem;
    position: absolute;
    right: 1.9rem;
  }
  .no_right button img{
    width: 5.75rem;

  }
  .no_right2 button img{
    width: 5.75rem;
    height: 2.84rem;

  }
  .no_right3 button img{
    width: 5.75rem;
    height: 2.84rem;

  }


  /*.kinter{ height: 47.5rem; background: #bf242a;}*/
  /*.gametun_bg{ height: 45.2rem; background: #bf242a; background-size: cover; position: absolute; top: 0; left: 0}*/
  .kinter{height: 47.5rem;}
  .gametun_bg{ height: 45.2rem; background-size: cover; position: absolute; top: 0; left: 0}
  .game_bottom{
    width: 20rem;
    height: 10rem;
    position: absolute;
    top: 40.6rem;
    left: 1.8rem;
    text-align: center;
    overflow: hidden;
  }
  .game_bottom_li{ width: 100%; height: 3.2rem; font-size: 0.9rem; color: #ffffff; line-height: 2.06rem; display: flex; align-items: center; justify-content: center;  white-space:nowrap;text-overflow:ellipsis;overflow:hidden; font-weight: bold }
  .game_bottom_li:nth-child(1){ margin-top: 0.2rem}
  .bottom_li_head{ width: 2.5rem; height: 2.5rem; border-radius: 10rem; overflow: hidden; border: 0.15rem solid; background: #ffffff; margin-left: 0.8rem; margin-right: 0.8rem}
  .conts_king{
    width: 15rem;
    height: 2rem;
    position: absolute;
    top: 9.5rem;
    left: 4.3rem;

  }
  .conts_king_in{ width: 7.5rem; height: 2rem; position: absolute; top: 0; left: 0; text-align: left; font-size: 0.85rem; color: #ffffff; line-height: 2rem}
  .conts_king_in2{ width: 7.5rem; height: 2rem; position: absolute; top: 0; right: 0; text-align: center;}
  .conts_king_bottom{
    width: 13rem;
    height: 0.8rem;
    position: absolute;
    bottom: 0.2rem;
    right: 1.3rem;
    text-align: right;
    font-size: 0.7rem;
    color: #e38e20;
    font-weight: bold;
  }
  .conts_king_left{ width: 9rem; height: 2rem; position: absolute; left: 2.4rem;}
  .conts_king_right{
    position: absolute;
    right: 2rem;
    top: 0.2rem;
    color: #fc585a;
    font-weight: bold;
    font-size: 0.7rem;

  }
  .pad_in{  font-weight: bold;-webkit-text-stroke: 0.05rem #e38e20; color: #fffd61}
  .pad_in2{ padding-left: 0.2rem; padding-right: 0.2rem; font-weight: bold; color: #7e39d4}

  .seamless-warp {
    height: 6.4rem;
    overflow: hidden;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .game_rule{ width:21.4375rem; height: 100vh; background: #ffffff; position: absolute; top: 2.9rem; padding-right: 1rem;}
  .game_rule_lin{ width: 21.4375rem; height: 3rem; border-radius: 1rem 1rem 0 0; background: #ffffff; position: absolute; top: 1rem; left: 0}
  .game_rule_lin2{ width: 22.4375rem; height: 1rem; border-radius: 1rem 1rem 0 0; background: #ffffff; position: absolute; top: 1rem; left: 0}
  .game_padding{  padding-right: 1rem; padding-left: 1rem}
  .game_kin{ width: 21.4375rem; height: 26rem;  position: absolute; top: 0; left: 0; overflow-y: scroll}
  .game_kin2{ width: 21.4375rem; height: 22rem;  position: absolute; top: 0; left: 0; overflow-y: scroll}
  .game_padding_style{ font-size: 0.9rem; padding-top: 0.3rem}
  .game_padding_style2{ font-size: 0.8rem; margin-top: 1rem}
  .game_padding_bold{  font-weight: bold; font-size: 0.9rem}
  .game_padding_top{ margin-top: 0.7rem}
  .game_text_head{
    text-align: center;
    font-size: 1.2rem;
    font-weight: bold;
    padding-bottom: 0.7rem;
  }

  .no_long_kp{ width: 2.6rem; height: 2.6rem; background: #ffffff; border-radius: 10rem; display: flex; justify-content: center; align-items: center;}
  .no_long_kp2{ width: 4rem; height: 4rem; background: #ffffff; border-radius: 10rem; display: flex; justify-content: center; align-items: center;}
  .no_long_ju{ width: 2rem; height: 4rem; display: flex; justify-content: center; align-items: center; position: absolute;right: 6rem}
  .no_long5_in{ width: 2.6rem; height: 2.6rem; display: flex; justify-content: center; margin-bottom: 0.5rem; position: relative}

  .no_long_kp img{ width: 2.6rem; height: 2.6rem;}
  .no_long_kp2 img{ width: 4rem; height: 4rem;}
   /*.game_zp{ width: 27.6rem;*/
   /* position: absolute;*/
   /* top: -3.69rem;*/
   /* left: -1.78rem;}*/
  .game_text_ter{ padding-left: 1rem; padding-right: 1rem}
  .game_text_ter p br{ padding-top: 0.5rem}
  .bottom_li_cli{ width: 5.5rem;overflow: hidden;white-space: nowrap;text-overflow: ellipsis; padding-left:0.7rem; text-align: left; color: #eadb68; font-weight: bold}
  .scroll-content {
    position: relative;
    transition: top 0.5s;

  }

  .gamebanner_img{
    width: 22.8rem;
    height: 7.55rem;
    position: absolute;
    top: 1.5rem;
    left: 0.27em;
    overflow: hidden;
    border: 0.01rem solid #FFF;
  }
  .gamebanner_img_in{ max-width: 23rem;}
  .conts_inter{ font-weight: bold; -webkit-text-stroke: 0.05rem #e38e20;}
  .conts_lon{ width: 4.4rem; height: 2.2rem; position: absolute; left: 0.1rem; top: 0}
  .conts_ron{ width: 4.4rem; height: 2.2rem; position: absolute; right: 0.1rem; top: 0}
  .conts_music{ width: 2.18rem; height: 2.28rem; position: absolute; top: 12rem; left: 0.1rem; z-index: 2}
  .bt_yinyue1{ width: 2.18rem; height: 2.28rem; position: absolute; top: 0; left: 0}
  .bt_yinyue2{ width: 2.18rem; height: 2.28rem; position: absolute; top: 0; left: 0}
  .kitty_logo{ width: 6.59rem; height: 8rem; position: absolute; top: 18.3rem; left: 0.3rem;}
  .kitty_logo img{ width: 6.59rem; height: 8rem;}
  .kitty_two_button{ width: 23.4rem; height: 3.18rem; position: absolute; top: 23.3rem; left: 0;}
  .five_button{ width: 7.93rem; height: 3.18rem; position: absolute; left: 3.3rem;}
  .ten_button{ width: 7.93rem; height: 3.18rem; position: absolute; right: 3.3rem;}
  .five_button img{ width: 7.93rem; height: 3.18rem;}
  .ten_button img{ width: 7.93rem; height: 3.18rem;}
  .my-swipe .van-swipe-inter {
    width: 726px;
    height: 263px;
    color: #fff;
    font-size: 20px;
    line-height: 150px;
    text-align: center;
    background-color: #39a9ed;
  }

  .bg_gk{
    width: 23.4rem;
    position: absolute;
    top: 5.5rem;
  }

  .trans_xz{
    animation: rotate 3s linear infinite;
  }

  @keyframes rotate{from{transform: rotate(0deg)}
    to{transform: rotate(360deg)}
  }

  @-webkit-keyframes rotate{from{transform: rotate(0deg)}
    to{transform: rotate(360deg)}
  }

  .isOn{
    width: 2.18rem;
    height: 2.28rem;
    position: absolute;

    background: url("../../../images/sy_guan.png") 0 0 no-repeat;
    background-size:100%;
  }
  @keyframes rotating {
    from { -webkit-transform: rotate(0) }
    to { -webkit-transform: rotate(360deg) }
  }
  @-webkit-keyframes rotating {
    from { -webkit-transform: rotate(0) }
    to { -webkit-transform: rotate(360deg) }
  }

  .isOff{
    width: 2.18rem;
    height: 2.28rem;
    position: absolute;
    -webkit-animation: rotating 1.2s linear infinite;
    animation: rotating 1.2s linear infinite;
    background: url("../../../images/sy_kai.png") 0 0 no-repeat;
    background-size:100%;
  }

  .shangxia_img{ width: 2rem; position: fixed; top: 18rem; left: 5.5rem;}

  /deep/ .van-swipe__indicators{
   position: absolute;
   top: 6.9rem;
   left: 20.5rem;
    z-index: 2;
  }

   /deep/ .van-swipe__indicator{
     width: 0.5rem;
     height: 0.5rem;
     border-radius: 10rem;
     background: #FFFFFF;
     opacity: 1;
  }
   .swiper_buttomIn{
     width: 22.8rem;
     height: 0.8rem;
     position: absolute;
     bottom: 0;
     background: rgba(000,000,000,0.5);
   }

</style>






// WEBPACK FOOTER //
// src/components/page/game/gameTurntable.vue